/* global __webpack_public_path__ */
let cache = null;
let inFlight = null;

/** Cached app settings, or {} before loadAppSettings() resolves. */
export function getAppSettings() {
  return cache || {};
}

/** Test/host seam: set the cache directly; pass null to force a refetch on next load. */
export function setAppSettings(value) {
  cache = value;
}

/** Fetch and cache appsettings.json once; fails soft to {} (cache left null → retries). */
export async function loadAppSettings() {
  if (cache) return cache;
  if (inFlight) return inFlight;

  let baseUrl = (typeof __webpack_public_path__ !== 'undefined' && __webpack_public_path__) || '/';
  if (!baseUrl.endsWith('/')) baseUrl += '/';

  inFlight = (async () => {
    try {
      const response = await fetch(`${baseUrl}appsettings.json`, { cache: 'no-store' });
      if (!response.ok) throw new Error(`appsettings.json ${response.status}`);
      const data = await response.json();
      if (!data || typeof data !== 'object' || Array.isArray(data)) {
        throw new Error('appsettings.json is not a JSON object');
      }
      cache = data;
      return cache;
    } catch (error) {
      console.error('[downloads-ui] failed to load appsettings.json', error);
      return {}; // leave cache null so the next mount retries
    } finally {
      // Clear the in-flight promise so failures can retry and successes fall back to `cache`.
      inFlight = null;
    }
  })();

  return inFlight;
}
